import React, { useEffect, useState } from 'react';
import styles from './UserSection.module.css';
import HeaderList from '../common/HeaderList';
import HoldingsListController from './HoldingsListController';
import {Link} from "react-router-dom" 
import ArcsComponent from '../../graph/ArcsComponent';
import MyModal from "../../components/session_expired"
import MyLodder from '../lodder';
import { capitalise } from '../../utilities/capitalise';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import {BarChart, BarLabel, ChartContainer} from "@mui/x-charts"


import Skeleton from '@mui/material/Skeleton';       
import { 
    Typography,  
    Container, 
    Paper, 
    Button,   
    useMediaQuery,
    Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';



const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#0B1420' : '#fff',
    backgroundImage : "none",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    }));

const UserSection = ({ 
  userInfo,
  // userNetAssets, 
  // userProfitNotional, 
  // userProfitBooked, 
  setSectionToShow ,
  showmodal,
  showlodder,
  margindata}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const screen400px = useMediaQuery('(max-width :400px)')
  const screen800px = useMediaQuery('(max-width :880px)')
  const screen930px = useMediaQuery('(max-width :980px)')
  const screen1000px = useMediaQuery('(max-width :1000px)')
  const screen1150px = useMediaQuery('(max-width :1150px)')
  const [circleData ,setCircleData] = useState({})
  const navigate = useNavigate();
  console.log('margindata',margindata)
  const handleAddFundsClick = () => {
    setSectionToShow("addfunds");  
    navigate('/dashboard/addfunds');
  };
  const withdrawFundsClick = () => {
    setSectionToShow("withdraw");
    navigate('/dashboard/withdraw');
  };
  const marginPledgeClick = () => {
    setSectionToShow("marginpledge");
    navigate('/dashboard/marginpledge');
  };

  // useEffect(()=>{
  //   window.scrollTo(0, 0)
    

  //   const newData = {
  //     title : "Net Assets",
  //     data : userNetAssets?.data.slice(0,2)
  //   }
  //   newData.data?.push({name : "Profit Notional" , value : userProfitNotional.notional, color  : "#7DAB1C"})
    
  //   setCircleData(newData)
  // },[userNetAssets]) 
   

  return (
    <Container className={styles.usersection} style={{background : isSmallScreen && "#1B2636" , width : "100%"}}>
      <Toolbar className={styles.toolbar}>
        {/* Font size changed to 20px - 29-07-24 - Dev Srini */}
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'left', marginLeft : !isSmallScreen ? "-25px" : "5px", marginTop : "15px", lineHeight : "1.2 !important",marginRight : "10px"  }}>
          Hi {userInfo && capitalise(userInfo.CLIENT_NAME)}
        </Typography>     
        {!screen800px && <Typography variant="caption" sx={{marginRight : !isSmallScreen && "-20px", color : "#999999"}}>
          Updated On {new Date().toISOString().split('T')[0]}
        </Typography>} 
      </Toolbar> 
      <Grid display={screen800px && "flex"} justifyContent="space-between">
      {screen800px && !isSmallScreen && <Typography variant="caption" sx={{marginRight : !isSmallScreen && "-20px", color : "#999999" , marginTop : "7.5px"}}>
          Updated On {new Date().toISOString().split('T')[0]}
        </Typography>}   
        {!isSmallScreen && <Typography sx={{textAlign : "right"}}>
       
       
        </Typography>}
        </Grid>
        { isSmallScreen ? 
            <Container sx={{paddingLeft: 0, paddingRight: 0}}>
              <Grid container spacing={2}>
                <Grid xs sx={{margin : "10px 0px 0px 20px"}}>
                    <Typography className={styles.marginavailable} variant="caption" sx={{ flexGrow: 1 }}>
                    ₹ {parseFloat(margindata && margindata.RMSSubLimits?.netMarginAvailable).toFixed(2)} 
                    </Typography>
                    <Typography className={styles.marginavailabletext}>
                      Available Margin / Cash 
                    </Typography>
                </Grid>
                <Grid xs sx={{margin : "10px 0px 0px 20px"}}>
                  <Typography className={styles.marginused} variant="caption" sx={{ flexGrow: 1 , textAlign : "end"}}>
                  ₹ {parseFloat(margindata && margindata.marginAvailable?.TotalMarginUsed).toFixed(2)}<br></br>  
                    </Typography>
                    <Typography className={styles.marginavailabletext}>
                      Used Margin 
                    </Typography>
                </Grid>
                <Grid container rowSpacing={1} xs={12} mb={2}>
                  <Grid xs={6} >
                    {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
                    <Button 
                      variant="contained" 
                      size="small" 
                      sx={{marginLeft : "15px"}}
                      className={styles.mainbutton}
                      onTouchStart={handleAddFundsClick} 
                      fullWidth>Add Funds</Button>
                  </Grid>
                  <Grid xs={5.5} >
                    {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
                    <Button 
                      variant="contained" 
                      size="small"
                      sx={{ marginLeft : "10px"}} 
                      className={styles.mainbutton}
                      onTouchStart={withdrawFundsClick} 
                      fullWidth>Withdraw</Button>
                  </Grid>
                {/*  <Grid xs={12}>
                    <Button variant="contained"
                        className={styles.outlinedbutton}
                        onClick={marginPledgeClick} 
                        size="medium" fullWidth>Margin Pledge CDSL</Button>
        </Grid>*/}
                </Grid>
                </Grid>
                {
                // !userNetAssets && !userProfitBooked && !userProfitNotional ? 
              //   (
              //   <Grid container spacing={1} sx={{margin : "10px 15px 0px 10px"}} >
              //   {[1,2,3].map((ele, i) =>{
              //     return(
              //       <Grid xs={12} key={i}>
              //   <Item className={styles.gridItems}>
              //   {/* key warning corrected - 29-07-24 - Dev Srini */}
              //   <Skeleton variant="rectangular" animation="wave" sx = {{background : "transparent" , width : "100%" , minHeight : "210px" , borderRadius : "5px"}}></Skeleton>
              //   </Item>
              // </Grid>
              //     )
              //   })}
              //   </Grid>) 
                // :
                 (
                <Grid container spacing={1} sx={{margin : "10px 15px 0px 10px"}} >
                  {/* <Grid xs={12} sx={{paddingLeft : "10px !important"}}  >
                    <Item className={styles.gridItems} sx={{backgroundColor :  "#0F1825" , display : "flex" , justifyContent : "center"}}>
                      <ArcsComponent circleData={circleData}/>
                      
                      </Item>
                      
                  </Grid> 
                  <Grid xs={12}>
                    <Item className={styles.gridItems}>
                      <HeaderList
                      items={userProfitBooked && userProfitBooked.items}
                      header={"Profit Booked"}
                      subheader={userProfitBooked?.profitBooked === 0 ? "0" : parseFloat(userProfitBooked?.profitBooked).toFixed(2) }
                      /></Item>
                  </Grid>
                  <Grid xs={12}>
                      <Item className={styles.gridItems} >
                      <HeaderList
                      items={userProfitNotional && userProfitNotional.items}
                      header={"Profit Notional"}
                      subheader={userProfitNotional?.notional === 0 ? "0" : parseFloat(userProfitNotional?.notional).toFixed(2)}
                      /></Item>
                  </Grid> */}
                  {/* <Grid xs={12}>
                    <Item>
                      <HeaderList
                        items={data.userLedger.items}
                        header={data.userLedger.name}
                        />
                    </Item>
                  </Grid> */}
                  <Grid container xs={12} sx={{ padding:0 }} spacing={1}>
                    {/* Commented by dev-trupti to check the XTS token login - 2 */}
                    <HoldingsListController/> 
                  </Grid>
                </Grid>)}
            </Container> : <>
            <Grid container spacing={3} sx={{justifyContent : "space-between" , marginTop : "2px"}}>
              <Grid xs>
                <Typography className={styles.marginavailable} variant="caption" sx={{ flexGrow: 1 }}>
                ₹ {parseFloat(margindata && margindata.RMSSubLimits?.netMarginAvailable).toFixed(2)}
                </Typography>
                <Typography className={styles.marginavailabletext}>
                  Available Margin / Cash
                </Typography>
              </Grid>
              <Grid xs>
              <Typography className={styles.marginused} variant="caption" sx={{ flexGrow: 1 }}>
              ₹ {parseFloat(margindata && margindata.marginAvailable?.TotalMarginUsed).toFixed(2)}<br></br> 
                </Typography>
                <Typography className={styles.marginavailabletext}>
                  Used Margin 
                </Typography> 
              </Grid> 
              <Grid xs = {screen800px && 12} sx={{display : "flex",justifyContent : screen800px ? "left" : "right", padding : "24px 0px 0px 0px"}} mb={2}>  
              <Item sx={{ background: "#180D2B"}}>
                  <Button variant="contained" size="small" className={styles.buttons1} onClick={handleAddFundsClick} >Add Funds</Button> 
                  <Button variant="contained" size="small" className={styles.buttons2} onClick={withdrawFundsClick} >Withdraw</Button>
                  {/* Commented margin pledge button - 02-08-24 - Dev Srini */}
                  {/* <Button variant="contained" size="small" className={styles.buttons2} onClick={marginPledgeClick} sx={{ lineHeight : 1.3}} >Margin Pledge</Button>  */}
                </Item>
              </Grid> 
            </Grid>
            {/* key warning corrected - 29-07-24 - Dev Srini */}
            {/* {!userNetAssets && !userProfitBooked && !userProfitNotional? (<Grid container spacing={1} minHeight={250} minWidth={250} sx={{marginTop : "30px"}}>
            {[1,2,3].map((ele, i) =>{
                  return(
                    <Grid sm = {screen800px ? 12 : 4.5} md= {4}  minHeight={250} key={i}>
                <Item>
                <Skeleton variant="rectangular" animation="wave" sx = {{background : "transparent" , width : "100%" , minHeight : "221px" , borderRadius : "5px"}}></Skeleton>
                </Item>
              </Grid>
                  )
                })} 
            </Grid>) : 
            (<Grid container spacing={1} minHeight={250} minWidth={250} sx={{marginTop : "30px", gap : screen1000px ? "0px" :"15px", display : "flex" , justifyContent : "space-between"}}>
              <Grid sm = {screen800px && 12 || screen930px && 4.5 || screen1000px && 4 || 3.85}  >
              <Item className={styles.gridItems} sx={{backgroundColor :  "#0F1825" , display : "flex" , justifyContent : "center"}}>
                      <ArcsComponent circleData={circleData}/>
                      </Item>
              </Grid>
              <Grid sm = {screen800px && 6 || screen930px && 3.75 || screen1000px && 4 || 3.85} minHeight={250}>  
                <Item className={styles.gridItems} sx={{padding : "8px 16px"}}  > 
                  <HeaderList 
                   items={userProfitBooked && userProfitBooked.items}
                   header={"Profit Booked"}
                   subheader={userProfitBooked?.profitBooked === 0 ? "0" : parseFloat(userProfitBooked?.profitBooked).toFixed(2) }
                  />
                </Item>
              </Grid>
              <Grid sm = {screen800px && 6 || screen930px && 3.75 || screen1000px && 4 || 3.85}>
                <Item className={styles.gridItems} sx={{padding : "8px 16px"}}> 
                  <HeaderList
                  items={userProfitNotional && userProfitNotional.items}
                  header={"Profit Notional"}
                  subheader={userProfitNotional?.notional === 0 ? "0" : parseFloat(userProfitNotional?.notional).toFixed(2)}
                  />
                </Item> 
              </Grid>  */}
              {/* <Grid xs>
                <Item>
                  <HeaderList
                    items={data.userLedger.items}
                    header={data.userLedger.name}
                    />
                </Item>
              </Grid> */}
            {/* </Grid>)} */}
            <Grid xs sx={{width : "100%"}} >
              <Item sx={{background : "#000000" , width : "100%", padding : "0px"}}>
                {/* Commented by dev-trupti to check the XTS token login - 3 */}
                <HoldingsListController/> 
              </Item>
            </Grid>
            </>
        }
        <MyModal canShow={showmodal}/>
        <MyLodder canShow={showlodder}/>
    </Container>
  );
};

export default UserSection;
